export const CIRCLE = 2 * Math.PI;

export function drawRectangle(context, x, y, width, height, stroke = true, fill = true) {
  context.beginPath();
  context.rect(x, y, width, height);
  fill && context.fill(); stroke && context.stroke();
}

export function drawEllipse(context, x, y, width, height, stroke = true, fill = true) {
  const radiusX = width / 2;
  const radiusY = height / 2;
  context.beginPath();
  context.ellipse(x + radiusX, y + radiusY, radiusX, radiusY, 0, 0, CIRCLE);
  fill && context.fill(); stroke && context.stroke();
}

export function drawTriangle(context, x0, y0, x1, y1, x2, y2, stroke = true, fill = true) {
  context.beginPath();
  context.moveTo(x0, y0);
  context.lineTo(x1, y1);
  context.lineTo(x2, y2);
  context.lineTo(x0, y0);
  fill && context.fill(); stroke && context.stroke();
}

export function drawDiamond(context, x, y, width, height, stroke = true, fill = true) {
  context.beginPath();
  const rx = width / 2;
  const ry = height / 2;
  context.moveTo(x + rx, y);
  context.lineTo(x + width, y + ry);
  context.lineTo(x + rx, y + height);
  context.lineTo(x, y + ry);
  context.lineTo(x + rx, y);
  fill && context.fill(); stroke && context.stroke();
}

export function drawStar(context, cx, cy, spikes, outerRadius, innerRadius, stroke = true, fill = true) {
  context.beginPath();
  let rot = Math.PI / 2 * 3; // Angle at top
  let x = cx;
  let y = cy;
  const step = Math.PI / spikes;
  context.moveTo(cx, cy - outerRadius);
  for (let i = 0; i < spikes; i++) {
    rot += step;
    x = cx + Math.cos(rot) * innerRadius;
    y = cy + Math.sin(rot) * innerRadius;
    context.lineTo(x, y);
    rot += step;
    x = cx + Math.cos(rot) * outerRadius;
    y = cy + Math.sin(rot) * outerRadius;
    context.lineTo(x, y);
  }
  fill && context.fill(); stroke && context.stroke();
}

export function drawRectangles(context, x, y, width, height, xCount = 3, yCount = 3, startFilled = true, stroke = true, fill = true) {
  const sx = width / xCount;
  const sy = height / yCount;
  for (let iy = 0; iy < yCount; ++iy) {
    const startRowFilled = (iy + startFilled) & 1;
    for (let ix = 0; ix < xCount; ++ix) {
      if ((ix + startRowFilled) & 1) {
        drawRectangle(context, x + ix * sx, y + iy * sy, sx, sy, stroke, fill);
      }
    }
  }
}
